<template>
  <span />
</template>

<script setup lang="ts">
import { onUnmounted, toRef, watch, watchEffect } from 'vue'
import { useFieldView } from '@/components/field-view-next/FieldViewState'
import { useRoute } from 'vue-router/composables'

const props = defineProps<{
  jobIds: string[]
}>()

const jobIdsRef = toRef(props, 'jobIds')

const { setSelectedJobNumbers, setSelectedLocation, setSelectedResource, setSelectedJobNumber } =
  useFieldView()

const route = useRoute()
watch(
  [() => route.name, jobIdsRef],
  ([name, jobIds]) => {
    if (name === 'fvnext-job-request') {
      setSelectedJobNumbers(jobIds)
      setSelectedLocation(null)
      setSelectedResource(null)
      setSelectedJobNumber(null)
    }
  },
  { immediate: true },
)

onUnmounted(() => {
  setSelectedJobNumbers([])
})
</script>

<style scoped></style>
